import * as eventRoutines from '../Containers/Events/eventRoutines';
import * as scheduleRoutines from '../Containers/Schedule/scheduleRoutines';
import { GenericObj } from '../Interfaces/objects';
import { ISessionMS, RegistrantMS } from '../Interfaces/Event.interface';
import produce from 'immer';

interface IEventWideState {
    sitePages: string[];
    sessions: ISessionMS[];
    invitees: GenericObj;
    // Used to process reg question responses
    inviteesWithData: GenericObj;
    registrants: GenericObj;
    sessionsLoading: boolean;
    sessionsLoaded: boolean;
    sessionsPublished: boolean;
    fetchingEventInvitees:boolean;
    eventInviteesCount: number;
}
const initialState: IEventWideState = {
    invitees: {},
    inviteesWithData:{},
    registrants: {}, //Only used for MS at the moment
    sessions: [],
    sitePages: [],
    /* for MS importing */
    sessionsLoading: false,
    /* for MS importing */
    sessionsLoaded: false,
    /*for MS publishing */
    sessionsPublished: false,
    fetchingEventInvitees: false,
    eventInviteesCount: 0
};

export default function reducer(state = initialState, action: any = {}) {
    switch (action.type) {
        case eventRoutines.fetchSitePagesForEvent.SUCCESS:
            return produce(state, draft => {
                draft.sitePages = action.payload;
            });
        case eventRoutines.fetchSessionsForEvent.SUCCESS:
            // return true;
            return produce(state, draft => {
                draft.sessions = action.payload.items;
                draft.sessionsLoaded = action.payload;
            });
        case eventRoutines.fetchSessionsForEvent.REQUEST:
            return produce(state, draft => {
                draft.sessionsLoading = action.payload;
            });

        case scheduleRoutines.publishImportedSessions.SUCCESS:
            return produce(state, draft => {
                draft.sessionsPublished = action.payload;
            });
        case eventRoutines.fetchInviteesBatchForEvent.SUCCESS:
            let invitees: GenericObj = {};

            //Let's try and move this platform-specific login into separate sagas so that reducer can stay consistant across platforms
                action.payload.map((i: any) => {
                    invitees[i.relationships.user.id] = i
                    return true;
                });


            return produce(state, draft => {
                draft.invitees = { ...state.invitees, ...invitees };
            });

        case eventRoutines.fetchRegistrantsBatchForEvent.SUCCESS:
            let registrants: GenericObj = {};

            action.payload.map((registrant: RegistrantMS) => {
                const registrantId = registrant['owner.Id'] ? registrant['owner.Id'] : '';
                registrants[registrantId] = registrant['owner.Name'] ? registrant['owner.Name'] : '';
                return true;
            });

            return produce(state, draft => {
                draft.registrants = { ...state.registrants, ...registrants };
            });

        case eventRoutines.clearInviteesData.TRIGGER:
            return produce(state, draft => {
                draft.invitees = {};
            });
        case eventRoutines.clearSessionsData.TRIGGER:
            return produce(state, draft => {
                draft.sessions = [];
                draft.sessionsLoaded = false;
                draft.sessionsLoading = false;
                draft.sessionsPublished = false;
            });

        case eventRoutines.clearRegistrantsData.TRIGGER:
            return produce(state, draft => {
                draft.registrants = {};
            });
        case eventRoutines.clearSitePagesData.SUCCESS:
            return produce(state, draft => {
                draft.sitePages = [];
            });
        case eventRoutines.syncGuestListWithActiveUsers.TRIGGER:
            return produce(state, draft => {
                draft.fetchingEventInvitees = true;
            });

        case eventRoutines.syncGuestListWithActiveUsers.SUCCESS:
        case eventRoutines.syncGuestListWithActiveUsers.FAILURE:
            return produce(state, draft => {
                draft.fetchingEventInvitees = false;
            });
        case eventRoutines.fetchEventInviteesCounts.SUCCESS:
            return produce(state, (draft:any) => {
                draft.eventInviteesCount = action.payload['invitation-status-type-counts']['affirmative'];
            });
        default:
            return state;
    }
}
